import { For, Show, type JSX } from "solid-js";
import { A } from "@solidjs/router";
import BotStatusBadge from "./BotStatusBadge";
import Text from "./Text";
import { useTranslation } from "../hooks/useTranslation";
import type { ProxyBotDto } from "../api/generated/schemas";
import styles from "./ProxyBotList.module.css";

interface ProxyBotListProps {
  bots: ProxyBotDto[];
  title: string;
  empty: string;
  renderActions?: (bot: ProxyBotDto) => JSX.Element;
}

export default function ProxyBotList(props: ProxyBotListProps) {
  const { t } = useTranslation();

  return (
    <div class={styles.block}>
      <div class={styles.header}>
        <span class={styles.subtitle}>{props.title}</span>
        <span class={styles.count}>{props.bots.length}</span>
      </div>

      <Show when={props.bots.length > 0} fallback={<div class={styles.empty}>{props.empty}</div>}>
        <div class={styles.list}>
          <For each={props.bots}>
            {(bot) => (
              <div class={styles.row}>
                <div class={styles.identity}>
                  <BotStatusBadge state={bot.state} compact />
                  <span class={styles.username}>{bot.minecraftUsername}</span>
                  <Show when={bot.externalIdentity}>
                    <span class={styles.entry} title={t("PROXY_BOTS_ENTRY_TITLE")}>{bot.externalIdentity}</span>
                  </Show>
                </div>
                <div class={styles.meta}>
                  <span class={styles.owner} title={t("ADMIN_BOT_OWNER")}>
                    <i class="fa-solid fa-user" /> {bot.ownerUsername}
                  </span>
                  {props.renderActions?.(bot)}
                  <A class="btn btn-secondary btn-sm" href={`/botengine?bot=${bot.botId}&all=1`}>
                    <i class="fa-solid fa-pen-to-square" /> <Text val="ADMIN_BOT_MANAGE" />
                  </A>
                </div>
              </div>
            )}
          </For>
        </div>
      </Show>
    </div>
  );
}
